<template>
  <div class="list-box">
    <ul class="list-search">
      <el-space wrap style="flex: 1">
        <el-input
          v-model="state.params.keywords"
          style="width: 200px"
          placeholder="算税单号、名称"
          clearable
          @clear="
            delete state.params.keywords;
            onLoad();
          "
          @paste.enter="$onKeywordsPaste($event, state.params)"
        ></el-input>
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
    </ul>
    <ul class="list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column label="状态" sortable="status">
          <template #default="{ row }">
            <c_status arr-name="calctax_status" :value="row.status"></c_status>
          </template>
        </el-table-column>
        <el-table-column
          prop="order_id"
          label="单号"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="name"
          label="名称"
          :formatter="$tab_TextFormat"
          :min-width="160"
        />
        <el-table-column
          prop="d_tax_type_name"
          label="报税类型"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="tax_month"
          label="税期月度"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="withholding_agent_name"
          label="扣缴义务人"
          :formatter="$tab_TextFormat"
          :min-width="160"
        />
        <el-table-column
          prop="total_num"
          label="算税人数"
          :formatter="$tab_NumberFormat"
          align="center"
        />
        <el-table-column
          prop="done_num"
          label="已算税"
          :formatter="$tab_NumberFormat"
          align="center"
        />
        <el-table-column
          prop="undone_num"
          label="未算税"
          :formatter="$tab_NumberFormat"
          align="center"
        />
        <el-table-column
          prop="abnormal_num"
          label="算税异常"
          :formatter="$tab_NumberFormat"
          align="center"
        />
        <el-table-column
          label="操作"
          width="120"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Edit"
              @click="
                $store.commit('openMenu', {
                  path: 'CalcTaxOutsourceDetail',
                  title: '外协算税单详情-' + row.order_id,
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
              v-if="row.status === 0 && $judge_auth('53')"
            >
              算税填报
            </el-button>
            <el-button
              v-else
              type="primary"
              link
              icon="Search"
              @click="
                $store.commit('openMenu', {
                  path: 'CalcTaxOutsourceDetail',
                  title: '外协算税单详情-' + row.order_id,
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
            >
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { calctax_list } from "@/http/supplier";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
    name: "",
  };
}
export default {
  props: {
    supplier_id: Number,
  },
  setup(props) {
    const state = reactive(new InitFormData());
    onMounted(() => {
      state.params.withholding_agent_id = props.supplier_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      calctax_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    return {
      state,
      props,
      onLoad,
      onSortChange,
      onReset,
    };
  },
};
</script>
<style scoped></style>
